<page-content [fullPageWidth]="true">
  <header-elitment header
                   [hasSideMenu]="true">
  </header-elitment>
  <side-menu left-menu>
    <athlete-side-menu></athlete-side-menu>
  </side-menu>
  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>
  <module-content *ngIf="!is401 && !is404">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxFill >
        <athlete-annual-plan-box [organization]="organization" [athleteUser]="athleteUser" ></athlete-annual-plan-box>
      </div>
    </div>

    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="20px">
      <div fxFlex="75" fxFlex.lt-md="65">
        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px">
          <div *ngIf="rights.SHOW_COMMUNICATIONS || rights.SHOW_FEEDBACKS" fxFlex="30">

            <communication-box [organization]="organization" [athleteUser]="athleteUser" *ngIf="rights.SHOW_COMMUNICATIONS"></communication-box>
            <athlete-feedback-box [organization]="organization" [athleteUser]="athleteUser" *ngIf="rights.SHOW_FEEDBACKS"></athlete-feedback-box>

          </div>
          <div fxFlex="{{ rights.SHOW_COMMUNICATIONS || rights.SHOW_FEEDBACKS ? 70 : 100 }}">
            <div class="box">
              <div class="box-content calendar-box">
                <button mat-mini-fab
                        color="none"
                        class="more-button float-right"
                        [matTooltip]="'DisplayCalendar' | translate"
                        (click)="onOpenCalendarClicked()">
                  <mat-icon color="primary">zoom_in</mat-icon>
                </button>

                <agendas-calendar [organization]="organization"
                                  [athleteUser]="athleteUser"
                                  [agenda]="agenda"
                                  [data]="agendaData"
                                  [collapseBefore]="collapseBefore"
                                  [collapseAfter]="collapseAfter"
                                  [isSummaryHidden]="true">
                </agendas-calendar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div fxFlex="25" fxFlex.lt-md="35">
        <div fxLayout="column">
          <athlete-evaluation-box [athleteUser]="athleteUser" [organization]="organization"></athlete-evaluation-box>

          <athlete-last-test-box [athleteUser]="athleteUser" [organization]="organization"></athlete-last-test-box>

          <app-document-upload [organization]="organization" [athleteUser]="athleteUser" *ngIf="rights.SHOW_FILES"></app-document-upload>
        </div>
      </div>
    </div>
  </module-content>
</page-content>
